import { Modal } from "@/Common/Components/Modals/Modal";

interface IDeleteListAndListItemPopupControlProps {
    CancelClickOperation: number;
    OkClickOperation: number;
    ContainerId: string;
    Title: string;
    PatientId?: string;
    Message?: JSX.Element;
}

class DeleteListAndListItemPopupControlState {
    public newListName: string;
}

class DeleteListAndListItemPopupControl extends React.Component<IDeleteListAndListItemPopupControlProps, DeleteListAndListItemPopupControlState> {
    constructor(props: IDeleteListAndListItemPopupControlProps) {
        super(props);

        const initialState = new DeleteListAndListItemPopupControlState();
        initialState.newListName = "";
        this.state = initialState;
    }

    public render(): JSX.Element {
        return (
            <Modal
                showOverlay
                showX
                width={550}
                top={100}
                title={this.props.Title}
                onClose={() => this.onClose()}
                footer={(
                    <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                        <div>
                            <button
                                data-action="cancel"
                                className="btn btn-default push-right-5"
                                onClick={e => this.onCancelClick(e)}
                            >
                                {cacheStore.GetString("CancelLabel")}
                            </button>
                            <button
                                data-action="ok"
                                className="btn btn-primary"
                                onClick={e => this.onOkClick(e)}
                            >
                                {cacheStore.GetString("OKLabel")}
                            </button>
                        </div>
                    </div>
                )}
                draggable
            >
                <div className="row">
                    <div className="col-lg-12">
                        {this.props.Message}
                    </div>
                </div>
            </Modal>
        );
    }

    private onOkClick(e: React.MouseEvent): void {
        e.preventDefault();
        sessionStore.dispatch(this.props.OkClickOperation, { value: this.props.PatientId });
    }

    private onCancelClick(e: React.MouseEvent): void {
        e.preventDefault();
        this.onClose();
    }

    private onClose(): void {
        sessionStore.dispatch(this.props.CancelClickOperation);
    }
}

export { DeleteListAndListItemPopupControl };
